import { clsx } from 'clsx';
import { FunctionComponent, PropsWithChildren } from 'react';
import { BadgeState } from 'softcat:config/badge-state.ts';

type BadgeProperties = {
    status: BadgeState;
};

export const Badge: FunctionComponent<PropsWithChildren<BadgeProperties>> = ({ children, status }) => {
    return (
        <span
            className={clsx('items-center gap-x-1.5 text-xs font-medium', {
                'bg-cyan-100 text-cyan-800': status === BadgeState.INFO,
                'bg-green-100 text-green-800': status === BadgeState.VALID,
                'bg-lime-100 text-lime-800': status === BadgeState.READY,
                'bg-pink-100 text-pink-800': status === BadgeState.INACTIVE,
                'bg-purple-100 text-purple-800': status === BadgeState.REVIEW,
                'bg-red-100 text-red-800': status === BadgeState.ERROR,
                'bg-yellow-100 text-yellow-800': status === BadgeState.WARNING,
                'block rounded-lg p-1': !children,
                'inline-flex rounded-md px-2 py-1': children,
            })}
            data-testid={`${status}-badge`}
        >
            <svg
                aria-hidden="true"
                className={clsx('size-1.5', {
                    'fill-cyan-500': status === BadgeState.INFO,
                    'fill-green-500': status === BadgeState.VALID,
                    'fill-lime-500': status === BadgeState.READY,
                    'fill-pink-500': status === BadgeState.INACTIVE,
                    'fill-purple-500': status === BadgeState.REVIEW,
                    'fill-red-500': status === BadgeState.ERROR,
                    'fill-yellow-500': status === BadgeState.WARNING,
                })}
                viewBox="0 0 6 6"
            >
                <circle cx={3} cy={3} r={3} />
            </svg>
            {children}
        </span>
    );
};
